import { observable } from "mobx"
import BigPictureService from "../../../services/BigPictureService"
import FileSaver from 'file-saver'

export default class BigPictureStore {

    @observable listaAnos;
    @observable listaMeses;
    @observable listaClientes;

    @observable mesSelecionado;
    @observable anoSelecionado;
    @observable clienteSelecionado;

    @observable loadingRelatorio;

    constructor() {

        this.clienteSelecionado = null
        this.anoSelecionado = null
        this.mesSelecionado = null

        this.listaAnos = []
        this.listaMeses = []
        this.listaClientes = []

        this.loadingRelatorio = false

        this.download = document.createElement('a')
        document.body.appendChild(this.download)
        this.download.style = "display: none"
        this.download.target = "_blank"

        this.service = new BigPictureService()

        this.listarMeses()
        this.listarAno()
        this.listarClientes()
    }

    setMes = (event) => {
        this.mesSelecionado = event
    }

    setAno = (event) => {
        this.anoSelecionado = event
    }

    setCliente = (event) => {
        this.clienteSelecionado = event
    }


    listarAno = () => {
        this.service.ListarAno().then(response => {
            if (response && response.data && response.data.length > 0) {
                this.listaAnos = response.data.map(ano => ({ label: ano.toString(), value: ano }))
            }
        }).catch(err => console.error(err))
    }

    listarClientes = () => {
        this.service.ListarClientes().then(response => {
            if (response && response.data && response.data.length > 0) {
                this.listaClientes = response.data.map(cliente => ({ label: cliente.Razao, value: cliente.ParId }))
            }
        }).catch(err => console.error(err))
    }

    listarMeses = () => {
        this.listaMeses = [
            {
                label: "Janeiro",
                value: "01"
            },
            {
                label: "Fevereiro",
                value: "02"
            },
            {
                label: "Março",
                value: "03"
            },
            {
                label: "Abril",
                value: "04"
            },
            {
                label: "Maio",
                value: "05"
            },
            {
                label: "Junho",
                value: "06"
            },
            {
                label: "Julho",
                value: "07"
            },
            {
                label: "Agosto",
                value: "08"
            },
            {
                label: "Setembro",
                value: "09"
            },
            {
                label: "Outubro",
                value: "10"
            },
            {
                label: "Novembro",
                value: "11"
            },
            {
                label: "Dezembro",
                value: "12"
            },
        ]
    }

    pesquisar = () => {
        this.loadingRelatorio = true
        if (this.clienteSelecionado === null || this.mesSelecionado === null || this.anoSelecionado === null) {
            this.loadingRelatorio = false
            return
        }
        this.service.GerarRelatorio(
            this.clienteSelecionado.value,
            this.clienteSelecionado.label, `${10}-${this.mesSelecionado.value}-${this.anoSelecionado.value}`
        ).then(response => {
            if (response && response.data) {
                const { file, filename } = response.data
                FileSaver.saveAs(file, filename)
            }
        }
        ).catch(err => console.error(err)
        ).finally(() => this.loadingRelatorio = false)
    }

}


// WEBPACK FOOTER //
// ./src/modules/bigpicture/stores/BigPictureStore.js